import React, { useState, useRef } from 'react';
import { isAndroid, isMobile } from 'react-device-detect';
import Checkbox from 'material-ui/Checkbox';
import Snackbar from 'material-ui/Snackbar';
import { processVideoFile, VIDEO_ERROR_MESSAGES } from './VideoPicker';

const CHECKED_YES = 1;
const CHECKED_NO = 0;

function FormOther(props) {
  const [image, setImage] = useState({
    error: false,
    message: '',
    image: null,
  });

  const [data, setData] = useState({
    content: '',
    file: null,
    videoFile: null,
    videoDuration: null,
    videoMd5: null,
    checked: CHECKED_YES,
  });

  const [err, setErr] = useState({
    content: false,
  });

  // State xử lý video
  const [videoProcessing, setVideoProcessing] = useState(false);
  const [videoError, setVideoError] = useState('');
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);
  const [videoProgress, setVideoProgress] = useState(0);
  const processIdRef = useRef(0);

  const onChange = (name, value) => {
    setData({ ...data, [name]: value });
  };

  const getImageData = (file) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (ev) => {
      setImage({ error: false, message: '', image: ev.target.result });
    };
  };

  const selectFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileType = file.type;

    // Nhánh 1: ảnh hợp lệ — cancel video nếu đang progress + thay thế
    if (
      fileType === 'image/png' ||
      fileType === 'image/jpeg' ||
      fileType === 'image/jpg' ||
      fileType === 'image/gif'
    ) {
      processIdRef.current++;
      setVideoProcessing(false);
      setVideoProgress(0);
      setVideoError('');
      setVideoPreviewUrl(null);

      getImageData(file);
      setData({ ...data, file, videoFile: null, videoDuration: null, videoMd5: null });
      return;
    }

    // Nhánh 2: video hợp lệ (MP4 hoặc MOV)
    if (fileType === 'video/mp4' || fileType === 'video/quicktime') {
      const currentProcessId = ++processIdRef.current;
      setVideoProcessing(true);
      setVideoError('');
      setVideoProgress(0);
      setImage({ error: false, message: '', image: null });
      processVideoFile(file, {
        onProgress: (pct) => {
          if (processIdRef.current === currentProcessId) {
            setVideoProgress(pct);
          }
        },
        onError: (code) => {
          if (processIdRef.current !== currentProcessId) return;
          setVideoError(VIDEO_ERROR_MESSAGES[code]);
          setVideoProcessing(false);
          if (!data.videoFile && !data.file) {
            setVideoPreviewUrl(null);
          }
        },
        onSuccess: ({ compressedBlob, duration, md5Sum }) => {
          if (processIdRef.current !== currentProcessId) return;
          const thumbUrl = URL.createObjectURL(compressedBlob);
          setVideoPreviewUrl(thumbUrl);
          setData({
            ...data,
            file: null,
            videoFile: compressedBlob,
            videoDuration: duration,
            videoMd5: md5Sum,
          });
          setVideoProcessing(false);
        },
      });
      return;
    }

    // Nhánh 3: video sai format → chỉ show lỗi, KHÔNG xóa file cũ
    if (fileType.startsWith('video/')) {
      setVideoError(VIDEO_ERROR_MESSAGES['invalid_format']);
      setVideoProcessing(false);
    } else {
      setImage({ error: true });
    }
  };

  const onAccept = () => {
    const contentError = data.content.replace(/\s/g, '').length === 0;
    setErr({ content: contentError });
    if (!contentError) {
      props.onChangeStepCategory(1, { ...data, image: image.image });
    }
  };

  return (
    <div>
      <p className="titleTextBox">お問い合わせ内容 </p>
      <textarea
        className="inputCus inputContact"
        onChange={(e) => onChange('content', e.target.value)}
        placeholder="具体的にお問い合わせ内容をご記入ください。 スクリーンショットを添付いただきますと対応がスムーズになります。"
        value={data.content}
      />
      {err.content && (
        <p className="errMsgContact">お問い合わせ内容を入力してください</p>
      )}

      <div className="fileContact">
        <div className="btn-wrap btnFile">
          <label className="btn-raised color_white">
            <p className="btn-raised__text">ファイルを選択</p>
            <input
              type="file"
              className="btn-raised__file inputChooseFile"
              accept="image/png,image/jpeg,image/jpg,image/gif,video/mp4,video/quicktime"
              onChange={(e) => selectFile(e)}
            />
          </label>
        </div>

        {/* Preview ảnh */}
        {isMobile ? (
          <>
            {image.image && (
              <img src={image.image} className="imageContact" alt="preview" />
            )}
            <p className="txtFileContact">
              {image.image ? '写真1枚' : data.videoFile ? '動画1本' : 'ファイル未選択'}
            </p>
          </>
        ) : (
          <>
            <p className="txtFileContact">
              {image.image ? '写真1枚' : data.videoFile ? '動画1本' : 'ファイル未選択'}
            </p>
            {image.image && (
              <img src={image.image} className="imageContact" alt="preview" />
            )}
          </>
        )}

        {/* Progress nén video */}
        {videoProcessing && (
          <div className="txtFileContact" style={{ marginTop: 18 }}>
            <p>動画を処理中... {videoProgress}%</p>
            <div style={{ width: 100, height: 6, background: '#e0e0e0', borderRadius: 3, overflow: 'hidden' }}>
              <div style={{ width: `${videoProgress}%`, height: '100%', background: '#11ad9d', transition: 'width 0.3s' }} />
            </div>
          </div>
        )}

        {/* Preview video thumbnail */}
        {videoPreviewUrl && !videoProcessing && (
          <div style={{ position: 'relative', display: 'inline-block', marginTop: 8, marginLeft: 32 }}>
            <video
              src={videoPreviewUrl}
              style={{ width: 100, height: 'auto', display: 'block' }}
            />
            <span style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: 32,
              color: 'white',
              textShadow: '0 0 4px #000',
              pointerEvents: 'none',
            }}>
              ▶
            </span>
          </div>
        )}

        {/* Error video — dùng Snackbar bên dưới */}
      </div>

      <p className="titleTextBox" style={{ marginTop: 44 }}>返信の有無</p>
      <div
        className={
          isAndroid
            ? 'checkBoxContact checkBoxContactAndroid'
            : 'checkBoxContact checkBoxContactIOS'
        }
      >
        <Checkbox
          label="必要"
          onCheck={() => onChange('checked', CHECKED_YES)}
          checked={data.checked === CHECKED_YES}
          style={{ color: '#c7bfbf' }}
          labelStyle={{ fontWeight: 'normal' }}
        />
        <Checkbox
          label="不要"
          onCheck={() => onChange('checked', CHECKED_NO)}
          checked={data.checked === CHECKED_NO}
          style={{ color: '#c7bfbf' }}
          labelStyle={{ fontWeight: 'normal' }}
        />
      </div>
      <button onClick={onAccept} className="submitContact" disabled={videoProcessing}>
        内容確認
      </button>

      <Snackbar
        open={image.error}
        message={'ファイル形式が不正です。画像（PNG/JPG/GIF）または動画（MP4/MOV）を選択してください。'}
        autoHideDuration={2500}
        onRequestClose={() => setImage({ ...image, error: false })}
      />
      {/* STEL-1440: Snackbar lỗi video */}
      <Snackbar
        open={!!videoError}
        message={videoError}
        autoHideDuration={3000}
        onRequestClose={() => setVideoError('')}
      />
    </div>
  );
}

export default FormOther;
